import _take from 'lodash/take';
import _drop from 'lodash/drop';

// Utils
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import selectorWithoutMemoize from '@tekion/tekion-base/utils/selectorWithoutMemoize';

// Constants

var DEFAULT_VISIBLE_ACTION_COUNT = 3;
var getVisibleActions = function getVisibleActions(_ref) {
  var _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? EMPTY_ARRAY : _ref$actions,
    _ref$visibleActionCou = _ref.visibleActionCount,
    visibleActionCount = _ref$visibleActionCou === void 0 ? DEFAULT_VISIBLE_ACTION_COUNT : _ref$visibleActionCou;
  return _take(actions, visibleActionCount);
};
var getHiddenActions = function getHiddenActions(_ref2) {
  var _ref2$actions = _ref2.actions,
    actions = _ref2$actions === void 0 ? EMPTY_ARRAY : _ref2$actions,
    _ref2$visibleActionCo = _ref2.visibleActionCount,
    visibleActionCount = _ref2$visibleActionCo === void 0 ? DEFAULT_VISIBLE_ACTION_COUNT : _ref2$visibleActionCo;
  return _drop(actions, visibleActionCount);
};
var createActionsListProps = function createActionsListProps(visibleActions, hiddenActions) {
  return {
    visibleActions: visibleActions,
    hiddenActions: hiddenActions
  };
};
export var mapPropsToActionsListProps = selectorWithoutMemoize([getVisibleActions, getHiddenActions], createActionsListProps);